import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from "@shared/components/breadcrumb/breadcrumb.component";
import { TableElement, TableExportUtil, UnsubscribeOnDestroyAdapter } from "@shared";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { firstValueFrom, fromEvent } from "rxjs";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { MatButton, MatButtonModule, MatMiniFabButton } from "@angular/material/button";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableModule,
} from "@angular/material/table";
import { MatOption, MatRipple, MatRippleModule } from "@angular/material/core";
import { PrescriptionService } from "@core/http/table-data-services/prescription.service";
import { PrescriptionDataSource } from "@core/data-source/PrescriptionDataSource";
import { Prescription } from "@core/models/Prescription";
import { AuthManagementService } from "@core/service/auth-management.service";
import { UserRole } from "@core/models/Enums/UserRole";
import { FilterReceta } from "@core/models/FilterReceta";
import { MatFormField, MatLabel, MatSuffix } from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatInput } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { CommonModule, NgIf, NgOptimizedImage } from "@angular/common";
import { DefaultResponse } from "@core/models/Http/DefaultResponse";
import { BusinessGroup } from "@core/models/BusinessGroup";
import { CatalogsService } from "@core/http/catalogs.service";
import { Branch } from "@core/models/Branch";
import Swal from "sweetalert2";
import { FeatherIconsComponent } from "@shared/components/feather-icons/feather-icons.component";
import { DoDeleteComponent } from "@shared/components/do-delete/do-delete.component";
import { TopWidgetsComponent } from "@shared/components/top-widgets/top-widgets.component";
import { CreateEditService } from "@core/http/create-edit-service";
import { DoctorDetails } from "@core/models/DoctorDetails";
import { PatientDetails } from "@core/models/PatientDetails";
import { AuthUserData } from "@core/models/AuthUserData";
import { HttpMesageHandlerService } from "@core/service/http-mesage-handler";
import { PatientPinDialogComponent } from "@shared/components/patient-pin-dialog/patient-pin-dialog.component";
import { DoctorService } from "@core/http/table-data-services/Doctor.service";
import {downloadPrescriptionPdf, generatePrescriptionPdfBase64, openPrintWindow} from "@shared/utils/window.utils";

@Component({
  selector: 'app-prescription-list',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    CommonModule,
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    MatIcon,
    MatOption,
    MatSelect,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSuffix,
    MatTooltip,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    MatRipple,
    MatSort,
    MatDatepickerModule,
    MatPaginator,
    MatMiniFabButton,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgOptimizedImage,
    NgIf,
    FeatherIconsComponent,
    TopWidgetsComponent,
  ],
  templateUrl: './prescription-list.component.html',
  styleUrl: './prescription-list.component.scss',
})
export class PrescriptionListComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  data?: PrescriptionService;
  displayedColumns: string[] = [];
  dataSource!: PrescriptionDataSource;
  index?: number;

  userRole!: string;

  isAdmin: boolean;
  isDoctor: boolean;
  isPatient: boolean;
  isParticular: boolean;
  isDoctorLike: boolean;

  idMedico = '';
  idPatient = '';
  idSucursal: string = '';
  idGEMP = '';

  filterReceta: FilterReceta;
  private autoSearchTriggered = false;

  businessGroups: BusinessGroup[] = [];
  branches: Branch[] = [];

  opcionesDiaMesAnio = ['Dia', 'Mes', 'Año'];

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild('filter', { static: true }) filter?: ElementRef;

  protected readonly UserRole = UserRole;

  constructor(
    public httpClient: HttpClient,
    public dialog: MatDialog,
    private authManagement: AuthManagementService,
    private catalogsService: CatalogsService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private service: PrescriptionService,
    private ceService: CreateEditService,
    private doctorService: DoctorService,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();

    const userData: AuthUserData = this.authManagement.userData();

    this.userRole = userData.TipoUsuario;
    this.isAdmin = this.authManagement.isUserAdmin();
    this.isDoctor = this.authManagement.isUserDoctor();
    this.isPatient = this.authManagement.isUserPatient();

    // ✅ Particular debe comportarse igual que médico en esta pantalla
    this.isParticular = this.userRole === UserRole.Particular;
    this.isDoctorLike = this.isDoctor || this.isParticular;

    this.filterReceta = new FilterReceta({
      folio: '',
      dateFilter: 'Dia',
      endDate: null,
      idGEMP: '',
      idSucursal: '',
      startDate: null
    });

    // ✅ MEDICO y PARTICULAR usan la misma lógica
    if (this.isDoctorLike) {
      this.doctorService.getDoctorByIdUser(userData.IdUsuario).subscribe({
        next: (res: DefaultResponse<DoctorDetails>) => {
          this.idMedico = res.data.idMedico;
          this.idGEMP = userData.IdGEMP;
          this.idSucursal = userData.IdSucursal;
          this.triggerAutoSearchOnce();
        },
        error: (err: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(err);
          this.triggerAutoSearchOnce();
        }
      });
    }

    if (this.isPatient) {
      this.ceService.getpatientByIdUser(userData.IdUsuario).subscribe({
        next: (res: DefaultResponse<PatientDetails>) => {
          this.idPatient = res.data.idPaciente;
          this.triggerAutoSearchOnce();
        },
        error: (err: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(err);
          this.triggerAutoSearchOnce();
        }
      });
    }

    // ✅ SOLO ADMIN y usuarios que sí usan filtros de grupo/sucursal deben cargar catálogos
    // Particular NO debe cargar esto, igual que Medico
    if (!this.isDoctorLike) {
      if (this.isAdmin) {
        this.getBusinessGroups();
      } else if (userData.IdGEMP) {
        this.getBusinessGroupsById(userData.IdGEMP);
        this.getBranchesByGemp(userData.IdGEMP);
      }
    }
  }

  ngOnInit(): void {
    this.loadData(this.filterReceta, true);
    this.cd.detectChanges();
    this.setDisplayedColumns();
  }

  private triggerAutoSearchOnce(): void {
    if (this.autoSearchTriggered) return;

    this.filterReceta.dateFilter = 'Dia';
    this.autoSearchTriggered = true;
    this.buscar();
  }

  refresh(): void {
    this.ngOnInit();
  }

  addNew(): void {
    this.router.navigate(['prescription/create']).then();
  }

  exportExcel(): void {
    const exportData: Partial<TableElement>[] =
      this.dataSource.filteredData.map((x: Prescription) => ({
        Folio: x.folio ? x.folio : 'SIN FOLIO',
        Medico: x.nombreMedico,
        Cedula: x.cedulaGeneral,
        Especialidad: x.especialidad ? x.especialidad : 'SIN ESPECIALIDAD',
        Paciente: x.nombrePaciente,
        Edad: x.edad != null ? `${x.edad} AÑOS` : 'SIN EDAD',
        Patologia: x.patologias && x.patologias !== 'CIM10 CLASSIFICATION' ? x.patologias : 'SIN DIAGNOSTICO',
        GrupoEmpresarial: x.grupoEmpresarial,
        Sucursal: x.sucursal,
        FechaCreacion: x.fechaCreacion,
        Estatus: x.estatusReceta,
      }));

    TableExportUtil.exportToExcel(exportData, 'recetas');
  }

  public loadData(filterReceta: FilterReceta, control: boolean = false): void {
    // ✅ Particular se manda igual que Medico
    const userRole = this.isDoctorLike
      ? UserRole.Medico
      : this.isPatient
        ? UserRole.Paciente
        : '';

    const userId = this.isDoctorLike
      ? this.idMedico
      : this.isPatient
        ? this.idPatient
        : '';

    // ✅ Solo admin usa filtros de grupo/sucursal
    if (this.isAdmin) {
      filterReceta.idSucursal = this.idSucursal || null as any;
      filterReceta.idGEMP = this.idGEMP || null as any;
    } else {
      delete filterReceta.idSucursal;
      delete filterReceta.idGEMP;
    }

    this.data = new PrescriptionService(this.httpClient, this.httpMsgHandler);
    this.dataSource = new PrescriptionDataSource(
      this.data,
      this.paginator,
      this.sort,
      filterReceta,
      userRole,
      userId,
      control
    );

    this.subs.sink = fromEvent(this.filter?.nativeElement, 'keyup').subscribe(() => {
      if (!this.dataSource) return;
      this.dataSource.filter = this.filter?.nativeElement.value;
    });
  }

  getBusinessGroups(): void {
    this.catalogsService.getBusinessGroups().subscribe({
      next: (res: DefaultResponse<BusinessGroup[]>) => {
        this.businessGroups = [...res.data];
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  getBusinessGroupsById(idGEMP: string): void {
    this.catalogsService.getGempbyIdGemp(idGEMP).subscribe({
      next: (res: DefaultResponse<BusinessGroup>) => {
        this.businessGroups = [res.data];
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  getBranchesByGemp(idGEMP: string): void {
    if (!idGEMP) return;

    this.catalogsService.getBranchesByIdGEMP(idGEMP).subscribe({
      next: (res: DefaultResponse<Branch[]>) => {
        this.branches = [...res.data];
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  buscar(): void {
    const startDate = this.filterReceta.startDate ? new Date(this.filterReceta.startDate) : null;
    const endDate = this.filterReceta.endDate ? new Date(this.filterReceta.endDate) : null;

    if (startDate) {
      this.filterReceta.startDate = startDate.toISOString().split('T')[0];
    }

    if (endDate) {
      this.filterReceta.endDate = endDate.toISOString().split('T')[0];
    }

    if (startDate && endDate && startDate > endDate) {
      Swal.fire('ERROR', 'LA FECHA FINAL DEBE DE SER MAYOR QUE LA FECHA INICIAL.', 'error').then();
      return;
    }

    if (!startDate && !endDate && !this.filterReceta.dateFilter) {
      Swal.fire('ERROR', 'SELECCIONE RANGO DE FECHAS POR DIA, MES O AÑO', 'error').then();
      return;
    }

    if (this.filterReceta.folio !== '') {
      this.filterReceta.dateFilter = 'Dia';
    }

    // ✅ MEDICO y PARTICULAR no deben mandar grupo/sucursal
    if (this.isDoctorLike) {
      delete this.filterReceta.idSucursal;
      delete this.filterReceta.idGEMP;
    }

    this.loadData(this.filterReceta);
  }

  clearDate(field: 'startDate' | 'endDate'): void {
    this.filterReceta[field] = null;
  }

  onDateFilterChange(): void {
    if (this.filterReceta.dateFilter) {
      this.filterReceta.startDate = null;
      this.filterReceta.endDate = null;
    }
  }

  onDateChange(): void {
    if (this.filterReceta.startDate || this.filterReceta.endDate) {
      this.filterReceta.dateFilter = null as any;
    }
  }

  onBranchChange(idGemp: string): void {
    this.idSucursal = '';
    this.getBranchesByGemp(idGemp);
  }

  async descargarPDF(row: Prescription): Promise<void> {
    const { idReceta, idPaciente } = row;

    let pin: string | null = null;

    if (row?.detalleOculto) {
      const mode =
        this.isAdmin ? 'ADMIN'
          : this.isDoctorLike ? 'MEDICO'
            : this.isPatient ? 'PACIENTE'
              : 'MEDICO';

      const dialogRef = this.dialog.open(PatientPinDialogComponent, {
        disableClose: false,
        autoFocus: false,
        width: '560px',
        maxWidth: '92vw',
        panelClass: ['rmd-pin-dialog-panel'],
        data: { mode },
      });

      pin = await firstValueFrom(dialogRef.afterClosed());

      if (pin === undefined as any) return;
    }

    this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente, pin ?? null).subscribe({
      next: (res: string) => {
        void downloadPrescriptionPdf(res, `receta-${row.folio || idReceta}.pdf`);
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      }
    });
  }

  async enviarRecetaPorCorreo(row: Prescription): Promise<void> {
    const { idReceta, idPaciente } = row;

    let pin: string | null = null;

    if (row?.detalleOculto) {
      const mode =
        this.isAdmin ? 'ADMIN'
          : this.isDoctorLike ? 'MEDICO'
            : this.isPatient ? 'PACIENTE'
              : 'MEDICO';

      const dialogRef = this.dialog.open(PatientPinDialogComponent, {
        disableClose: false,
        autoFocus: false,
        width: '560px',
        maxWidth: '92vw',
        panelClass: ['rmd-pin-dialog-panel'],
        data: { mode },
      });

      pin = await firstValueFrom(dialogRef.afterClosed());

      if (pin === undefined as any) return;
    }

    try {
      const html = await firstValueFrom(this.catalogsService.getRecetaByIdReceta(idReceta, idPaciente, pin ?? null));
      const pdfBase64 = await generatePrescriptionPdfBase64(html, {
        title: 'Enviando receta...',
        subtitle: 'Estamos preparando el PDF para correo'
      });

      this.service.enviarRecetaPorCorreo({ idReceta, pdfBase64 }).subscribe({
        next: (res) => this.httpMsgHandler.handleMsg(res as any),
        error: (err: HttpErrorResponse) => this.httpMsgHandler.handleMsg(err)
      });
    } catch (err) {
      this.httpMsgHandler.handleMsg(err as HttpErrorResponse);
    }
  }

  printHtml(fullHtmlString: string): void {
    const printWidth = 1000;
    const printHeight = 800;

    const screenWidth = window.screen.width || 1920;
    const screenHeight = window.screen.height || 1080;

    const left = Math.max((screenWidth - printWidth) / 2, 0);
    const top = Math.max((screenHeight - printHeight) / 2, 0);

    const features = `width=${printWidth},height=${printHeight},top=${top},left=${left}`;
    const printWindow = openPrintWindow(features);

    if (!printWindow) {
      return;
    }

    printWindow.document.open();
    printWindow.document.write(fullHtmlString);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  }

  deleteItem(row: Prescription): void {
    const { idReceta } = row;

    const dialogRef = this.dialog.open(DoDeleteComponent, {
      data: {
        toDelete: 'RECETA',
        id: idReceta,
        name: 'ESTA RECETA',
        actionService: (id: string) => this.service.deletePrescription(id),
      }
    });

    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        const foundIndex = this.data?.dataChange.value.findIndex(
          (x): boolean => x.idReceta === idReceta
        );

        if (foundIndex != null && this.data) {
          this.refreshTable();
          this.refresh();
        }
      }

      this.buscar();
    });
  }

  async goToDetails(row: any): Promise<void> {
    const idReceta = row.idReceta;
    const idCodificado = btoa(idReceta);
    const fechaCodificada = btoa(row.fechaCreacion);
    const status = btoa(row.estatusReceta);

    let pin: string | null = null;

    if (row?.detalleOculto === true && row.timbrada) {
      const mode =
        this.isAdmin ? 'ADMIN' :
          this.isDoctorLike ? 'MEDICO' :
            this.isPatient ? 'PACIENTE' :
              'MEDICO';

      const dialogRef = this.dialog.open(PatientPinDialogComponent, {
        disableClose: false,
        autoFocus: false,
        width: '560px',
        maxWidth: '92vw',
        panelClass: ['rmd-pin-dialog-panel'],
        data: { mode },
      });

      pin = await firstValueFrom(dialogRef.afterClosed());
    }

    this.router.navigate(
      ['prescription/details/' + idCodificado + '/' + fechaCodificada + '/' + status],
      { state: { pin } }
    ).then();
  }

  timbrarReceta(row: any): void {
    const idReceta = row.idReceta;

    this.catalogsService.timbrarReceta(idReceta).subscribe({
      next: (response: any) => {
        this.httpMsgHandler.handleMsg(response);
        this.refreshTable();
        this.buscar();
      },
      error: (error) => {
        this.httpMsgHandler.handleMsg(error);
      }
    });
  }

  editarReceta(row: any): void {
    const idRecetaB64 = btoa(row.idReceta);
    const idPacienteB64 = btoa(row.idPaciente);

    this.router.navigate(['prescription', 'edit', idRecetaB64, idPacienteB64]).then();
  }

  expandirDiagnostico(row: any, expandir: boolean = true): void {
    row.expandirDiagnostico = expandir;
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = [
      'folio',
      'paciente',
      'diagnostico',
      'gemp',
      'creacion',
      'status',
      'acciones'
    ];

    if (this.isAdmin) {
      this.displayedColumns.splice(1, 0, 'medico');
    }
  }

  private refreshTable(): void {
    this.paginator._changePageSize(this.paginator.pageSize);
  }
}
